<script setup lang="ts">
import { MMText } from '@mm-frontend/mm-web-ui-kit';

defineProps<{
  fullPrice: number;
  sellPrice: number;
  isPrefixShown?: boolean;
}>();
</script>

<template>
  <div class="price-block">
    <MMText font="Headline M/Bold" font-mobile-or-tablet="Title S/Semibold">
      <template v-if="isPrefixShown">от </template>
      <CurrencyFormatter :value="sellPrice" />
    </MMText>

    <MMText font="Body M/Regular" font-mobile-or-tablet="Caption L/Regular" color="tertiary">
      <CurrencyFormatter v-if="fullPrice > sellPrice" :value="fullPrice" crossed-out />
    </MMText>
  </div>
</template>

<style scoped lang="stylus">
.price-block
  display flex
  align-items center
  gap 12px
  +Media(Mobile, Tablet)
    gap 8px
</style>
